import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { AddParticipantMutationRequest, AddParticipantMutationResponse, AddParticipantQueryParams, AddParticipant400, AddParticipant401, AddParticipant403, AddParticipant422, AddParticipant429, AddParticipant500 } from "../types/AddParticipant";

/**
 * @link /api/purchase-tenders/v1/participant
 */

export function useAddParticipant <TData = AddParticipantMutationResponse, TError = AddParticipant400 | AddParticipant401 | AddParticipant403 | AddParticipant422 | AddParticipant429 | AddParticipant500, TVariables = AddParticipantMutationRequest>(params: AddParticipantQueryParams, options: {
          mutation?: UseMutationOptions<ResponseConfig<TData>, TError, TVariables>,
          client?: Partial<Parameters<typeof client<TData, TError, TVariables>>[0]>,
      } = {}): UseMutationResult<ResponseConfig<TData>, TError, TVariables> {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};

  return useMutation<ResponseConfig<TData>, TError, TVariables>({
    mutationFn: (data) => {
      
      return client<TData, TError, TVariables>({
        method: "post",
        url: `/api/purchase-tenders/v1/participant`,
        data,
        params,
        
        ...clientOptions
      });
    },
    ...mutationOptions
  });
};
